module.exports = __webpack_public_path__ + "static/simonxti5-product_image_1400x1050 (1)-cc59f7687dcb695342ea0ed2e5021b4a.jpg";